import { render } from "./top-nav-small.vue?vue&type=template&id=32b04d5c&ts=true"
import script from "./top-nav-small.vue?vue&type=script&lang=ts"
export * from "./top-nav-small.vue?vue&type=script&lang=ts"

import "./top-nav-small.vue?vue&type=style&index=0&id=32b04d5c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__